import { getFormViewerContext } from "../ViewerContext/formViewerContext";

// @flow

export function publisherNameMatches(name: string): boolean {
  const vc = getFormViewerContext();
  if (!vc) return false;
  return vc.publisherName === name;
}
